<script>
import RechargePackage from '@/views/AadenPages/memberShipReborn/RechargeManagement/RechargePackage.vue'
import ConsumptionTransactionManagement
  from '@/views/AadenPages/memberShipReborn/RechargeManagement/ConsumptionTransactionManagement.vue'
import RechargeRefundTransactionManagement
  from '@/views/AadenPages/memberShipReborn/RechargeManagement/RechargeRefundTransactionManagement.vue'

export default {
  name: 'RechargeManagementIndex',
  components: {
    RechargePackage,
    ConsumptionTransactionManagement,
    RechargeRefundTransactionManagement
  },
  data () {
    return {
      tab: null
    }
  }
}
</script>

<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="primary"
      style="background: transparent"
    >
      <v-tab>充值套餐</v-tab>
      <v-tab>消费交易管理</v-tab>
      <v-tab>充值交易管理</v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <recharge-package />
      </v-tab-item>
      <v-tab-item>
        <consumption-transaction-management />
      </v-tab-item>
      <v-tab-item>
        <recharge-refund-transaction-management />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style scoped>
.v-tabs {
  margin-bottom: 16px;
}
</style>
